export default __webpack_public_path__ + "static/media/archies3.97676bb6.png";